<h2 mat-dialog-title>
  {{'reEditConfirmDialog.Confirmation' | translate}}
</h2>
<div class="container" fxLayout="column" fxLayoutAlign="center center">
  <p>{{'reEditConfirmDialog.MsgMakeNewRevision' | translate}}</p>
  <p>{{'reEditConfirmDialog.MsgActionReserved' | translate}}</p>
</div>
<div class="container" fxLayout="row" fxLayoutAlign="center center" position="fixed">
  <mat-dialog-actions fxFlex fxLayoutAlign="center center">
    <button mat-button color="primary" [mat-dialog-close]="false">{{'reEditConfirmDialog.No' | translate}}</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">{{'reEditConfirmDialog.Yes' | translate}}</button>
  </mat-dialog-actions>
</div>